interface Props {
  className?: string;
}

export const WhiteCheckmarkIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
    >
      <path
        d="M5.88856 8.76142L10.9955 3.65454L11.7811 4.44021L5.88856 10.3328L2.35303 6.79725L3.13871 6.01159L5.88856 8.76142Z"
        fill="#001F23"
      />
    </svg>
  );
};

export const LinkIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_4522_1112)">
        <path
          d="M6.66699 8.66697C6.95329 9.04972 7.31856 9.36642 7.73803 9.5956C8.15749 9.82477 8.62133 9.96105 9.09809 9.99519C9.57485 10.0293 10.0534 9.96055 10.5012 9.79349C10.9491 9.62643 11.3557 9.36502 11.6937 9.02697L13.6937 7.02697C14.3009 6.3983 14.6368 5.55629 14.6292 4.6823C14.6216 3.80831 14.2711 2.97227 13.6531 2.35424C13.035 1.73621 12.199 1.38565 11.325 1.37806C10.451 1.37046 9.609 1.70644 8.98033 2.31364L7.83366 3.45364"
          stroke="#343434"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33347 7.33381C9.04716 6.95106 8.68189 6.63435 8.26243 6.40518C7.84297 6.17601 7.37913 6.03973 6.90237 6.00559C6.4256 5.97144 5.94707 6.04023 5.49924 6.20729C5.0514 6.37435 4.64472 6.63576 4.3068 6.97381L2.3068 8.97381C1.69961 9.60248 1.36363 10.4445 1.37122 11.3185C1.37881 12.1925 1.72938 13.0285 2.3474 13.6465C2.96543 14.2646 3.80147 14.6151 4.67546 14.6227C5.54945 14.6303 6.39146 14.2943 7.02013 13.6871L8.16013 12.5471"
          stroke="#343434"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4522_1112">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconPlus = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M13.0467 11.0521H19.0332C19.5671 11.0521 20 11.485 20 12.019C20 12.5529 19.5671 12.9858 19.0332 12.9858H13.0467V18.9533C13.0467 19.5314 12.5781 20 12 20C11.4219 20 10.9533 19.5314 10.9533 18.9533V12.9858H4.96682C4.43286 12.9858 4 12.5529 4 12.019C4 11.485 4.43286 11.0521 4.96682 11.0521H10.9533V5.04673C10.9533 4.46864 11.4219 4 12 4C12.5781 4 13.0467 4.46864 13.0467 5.04673V11.0521Z"
        fill="white"
      />
    </svg>
  );
};

export const IconMinus = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M4 11.9944C4 11.4457 4.44581 11.0013 4.99456 11.0031L19.0348 11.049C19.5684 11.0507 20 11.4838 20 12.0174C20 12.5522 19.5664 12.9858 19.0316 12.9858H4.99133C4.44383 12.9858 4 12.5419 4 11.9944Z"
        fill="#03292E"
      />
    </svg>
  );
};

export const BlueCheckmarkIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      className={className}
    >
      <path
        d="M37.4156 12.207L17.8911 31.3949L8.12891 21.8009"
        stroke="#18C2DE"
        strokeWidth="6"
      />
    </svg>
  );
};
